import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type GetSaltoSpaceIsConnectedRequest = {
  email: string
}

export const getSaltoSpaceIsConnectedQueryKey = (data: GetSaltoSpaceIsConnectedRequest) => [
  'useGetSaltoSpaceIsConnected',
  data,
]

const getSaltoSpaceIsConnected = async (data: GetSaltoSpaceIsConnectedRequest) => {
  const response = await authAPI.get<boolean>('/salto-space/isconnected', {
    params: { email: data.email },
  })
  return response.data
}

export const useGetSaltoSpaceIsConnected = (data: GetSaltoSpaceIsConnectedRequest) =>
  useQuery({
    enabled: Boolean(data.email),
    queryFn: () => getSaltoSpaceIsConnected(data),
    queryKey: getSaltoSpaceIsConnectedQueryKey(data),
  })
